import type { SVGProps } from "react";
export interface Glasses02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Glasses02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Glasses02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m14 13.874.116.006a1.126 1.126 0 0 1 0 2.239l-.116.006h-4a1.125 1.125 0 0 1 0-2.25zM.875 13.5c0-1.01.27-2.41.583-3.72.32-1.341.715-2.7 1.014-3.678l.079-.233a4.04 4.04 0 0 1 2.516-2.41l1.577-.526a1.126 1.126 0 0 1 .711 2.136l-1.576.524c-.492.164-.88.518-1.08.967l-.075.198a62 62 0 0 0-.978 3.546c-.312 1.309-.52 2.477-.521 3.196a1.125 1.125 0 0 1-2.25 0m20 0c0-.719-.209-1.887-.522-3.196a52 52 0 0 0-.494-1.894l-.483-1.652a1.79 1.79 0 0 0-1.154-1.165l-1.578-.524-.107-.043a1.126 1.126 0 0 1 .708-2.124l.111.031 1.576.526a4.04 4.04 0 0 1 2.596 2.643l.498 1.703c.176.63.355 1.304.515 1.975.314 1.31.583 2.71.584 3.72a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M8.875 17v-2.67c-1.078-.31-1.987-.455-2.875-.455s-1.797.144-2.875.454v2.672c0 1.035.84 1.873 1.875 1.873h2A1.875 1.875 0 0 0 8.875 17m4 0v-3.5c0-.484.31-.915.769-1.068 1.572-.524 2.947-.807 4.356-.807 1.41 0 2.784.283 4.355.807.46.153.77.583.77 1.067v3.502A4.124 4.124 0 0 1 19 21.124h-2A4.125 4.125 0 0 1 12.875 17m-1.75 0A4.125 4.125 0 0 1 7 21.125H5A4.124 4.124 0 0 1 .875 17v-3.502c0-.484.31-.914.769-1.067 1.572-.524 2.948-.807 4.356-.807 1.41 0 2.784.283 4.355.807.46.153.77.584.77 1.068zm4 0c0 1.035.84 1.875 1.875 1.875h2A1.874 1.874 0 0 0 20.875 17v-2.672c-1.078-.31-1.987-.454-2.875-.454s-1.797.144-2.875.454z"
      />
    </svg>
  );
}
